import * as React from 'react';
import {Select} from './BlogFormInputs';

const BlogPostSelectClubGeneric = ({
  register,
  setValue,
  selectedClub,
  clubs,
}: any) => {
  React.useEffect(() => {
    console.log('Select Club Use Effect ' + selectedClub);
  }, [setValue, selectedClub]);
  if (clubs === undefined || clubs === null || clubs.length === 0) {
    return <></>;
  }
  return (
    <div className="mb-4 mr-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">Club</label>
      <Select
        name="Club"
        register={register}
        options={clubs}
        defaultValue={selectedClub}
      />
    </div>
  );
};
export default BlogPostSelectClubGeneric;
